<div mat-dialog-title class="import-product__header">
  <h2 class="import-product__title">
    {{ title }}
  </h2>
  <button
    mat-icon-button
    class="import-product__close"
    [mat-dialog-close]="true"
    aria-label="Close dialog"
  >
    <mat-icon color="warn">close</mat-icon>
  </button>
</div>


<div mat-dialog-content class="import-product">
  <div class="import-product__overlay" *ngIf="isLoading">
    <mat-progress-bar mode="determinate" [value]="progressValue" class="import-product__progress-bar"></mat-progress-bar>
    <span class="import-product__progress-text">{{ progressMessage || 'Importing tech stacks v2...' }}</span>
  </div>

  <ng-container *ngIf="!hasImported; else postImportView">
    <div class="import-product__summary" *ngIf="hasRows">
      Selected {{ selectedCount }} out of {{ totalCount }} items for import.
    </div>

    <ng-container *ngIf="hasRows; else emptyState">
      <div class="import-product__table-wrapper">
        <table
          mat-table
          [dataSource]="rows"
          [trackBy]="trackByCompanyAndProduct"
          class="import-product__table"
        >
          <ng-container matColumnDef="selected">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="import-product__select-column"
            ></th>
            <td
              mat-cell
              *matCellDef="let row"
              class="import-product__select-column"
            >
              <mat-checkbox
                color="primary"
                [checked]="row.selected"
                (change)="toggleRowSelection(row, $event.checked)"
              ></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef>Company</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.company || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="companyDomain">
            <th mat-header-cell *matHeaderCellDef>Company Domain</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.companyDomain || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="product">
            <th mat-header-cell *matHeaderCellDef>Product</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.product || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="vendor">
            <th mat-header-cell *matHeaderCellDef>Vendor</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.vendor || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="vendorDomain">
            <th mat-header-cell *matHeaderCellDef>Vendor Domain</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.vendorDomain || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="source">
            <th mat-header-cell *matHeaderCellDef>Source</th>
            <td mat-cell *matCellDef="let row">
              {{ row.source || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="probability">
            <th mat-header-cell *matHeaderCellDef>Probability</th>
            <td mat-cell *matCellDef="let row">
              {{ row.probability || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateFirstVerified">
            <th mat-header-cell *matHeaderCellDef>First Verified</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.dateFirstVerified || '-' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateLastVerified">
            <th mat-header-cell *matHeaderCellDef>Last Verified</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dto.dateLastVerified || '-' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #postImportView>
  <div
    class="import-product__summary import-product__summary--result"
    *ngIf="!hasImportError && hasResults"
  >
    {{ summaryMessage }}
  </div>
  <div class="import-product__error" *ngIf="hasImportError">
    {{ importErrorMessage }}
  </div>

  <ng-container *ngIf="hasResults; else postImportEmpty">
    <div class="import-product__table-wrapper">
      <table
        mat-table
        [dataSource]="importResults"
        [trackBy]="trackByResultRow"
        class="import-product__table"
      >
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let result">
            <span
              class="import-product__status"
              [class.import-product__status--success]="getResultStatus(result) === 'Success'"
              [class.import-product__status--failed]="getResultStatus(result) === 'Failed'"
            >
              {{ getResultStatus(result) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef>Company</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.company || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="companyDomain">
          <th mat-header-cell *matHeaderCellDef>Company Domain</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.companyDomain || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef>Product</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.product || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="vendor">
          <th mat-header-cell *matHeaderCellDef>Vendor</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.vendor || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="vendorDomain">
          <th mat-header-cell *matHeaderCellDef>Vendor Domain</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.vendorDomain || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateFirstVerified">
          <th mat-header-cell *matHeaderCellDef>First Verified</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.dateFirstVerified || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="dateLastVerified">
          <th mat-header-cell *matHeaderCellDef>Last Verified</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.dateLastVerified || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="intensity">
          <th mat-header-cell *matHeaderCellDef>Intensity</th>
          <td mat-cell *matCellDef="let result">
            {{ result.stack?.intensity ?? '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="errors">
          <th mat-header-cell *matHeaderCellDef>Errors</th>
          <td mat-cell *matCellDef="let result">
            {{ getResultErrors(result) || '-' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="resultColumns"></tr>
        <tr
          mat-row
          *matRowDef="let result; columns: resultColumns"
        ></tr>
      </table>
    </div>
  </ng-container>
</ng-template>

<ng-template #emptyState>
  <div class="import-product__empty">
    <p>No data available.</p>
  </div>
</ng-template>

<ng-template #postImportEmpty>
  <div class="import-product__empty" *ngIf="!hasImportError">
    <p>No data returned from import.</p>
  </div>
</ng-template>

<mat-dialog-actions align="end" class="import-product__actions">
  <button mat-flat-button type="button" (click)="onClose()">
    {{ hasImported ? 'Close' : 'Cancel' }}
  </button>
  <button
    *ngIf="!hasImported"
    mat-flat-button
    color="primary"
    type="button"
    (click)="onConfirm()"
    [disabled]="!selectedCount || isLoading"
  >
    <span *ngIf="!isLoading">Import</span>
    <span *ngIf="isLoading">Importing...</span>
  </button>
</mat-dialog-actions>
